import React from 'react';
import { isDevOrLocal } from '../../utils/env';
import { FILE_NOT_FOUND } from '../../api/redux-route/routes';
import RouteRenderer from './RouteRenderer';

export default class DevRoute extends React.Component {
  render() {
    return (
      <RouteRenderer
        redirectTo={FILE_NOT_FOUND}
        hasAccess={isDevOrLocal()}
        {...this.props}
      />
    );
  }
}
